export default __webpack_public_path__ + "static/switch-to-relative-drop-off-light-mode-03f129248bf7d1c7f40ceaf821f6cc9b.png";